import * as Factory from 'factory.ts'
import faker from 'faker'

import { type AccountCode } from '../../models'

export const AccountCodeMock = Factory.Sync.makeFactory<AccountCode>({
  id: Factory.each(() => faker.random.number()),
  active: true,
  applied_accounts_count: faker.random.number(),
  code: Factory.each(() => faker.finance.account(4)),
  code_length: faker.random.number(),
  description: Factory.each(() => faker.finance.accountName()),
  account_type: faker.random.number(),
  parent: faker.random.number(),
})
